import { render, staticRenderFns } from "./SelectFolderModal.vue?vue&type=template&id=f74d8ad0&lang=pug"
import script from "./SelectFolderModal.vue?vue&type=script&lang=js"
export * from "./SelectFolderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports